import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggler: 'toggle'
            }
        }
    }

    init() {

    }

    /**
     * Toggler
     *
     * @param item {node}
     */
    toggle(e) {
        let item = e.curTarget
        let parent = item.parentNode

        if(parent.classList.contains('is-open')) {
            this.close()
        } else {
            this.close()
            this.open(parent)
        }
    }

    /**
     * open
     *
     * @param parentNode item {node}
     */
    open(item) {
        let collapsible = item.querySelector('[data-accordion="content"]')
        item.classList.add('is-open');

        gsap.to(collapsible, 0.3, {
            height: this.compute(item.querySelector('[data-accordion="inner"]')).height,
            onComplete: () => {
                this.call('update', null, 'Scroll')
                this.call('scrollTo', [item], 'Scroll', 'main')
            }
        })
    }

    /**
     * Close
     *
     * @param
     */
    close() {
        this.$('item').forEach((item) => {
            item.classList.remove('is-open')

            let collapsible = item.querySelector('[data-accordion="content"]')

            if(collapsible) {
                gsap.to(collapsible, 0.3, {
                    height: 0,
                    onComplete: () => {
                        this.call('update', null, 'Scroll')
                    }
                })
            }
        })
    }

    /**
     * compute
     *
     * @param
     */
    compute(item) {
        return item.getBoundingClientRect();
    }
}
